import styled from 'styled-components';

import colors from '../../../styles/colors';
interface IButtonProps {
  disabled?: boolean;
}

export const ButtonDark = styled.button`
  height: 45px;
  width: 200px;
  padding: 5px 0;

  display: flex;
  justify-content: center;
  align-items: center;

  border: 0;
  border-radius: 3px;
  background-color: ${colors.blueEinstein};

  font-family: 'Montserrat', sans-serif;
  color: ${colors.white};
  font-weight: 400;
  font-size: 16px;

  cursor: ${(props: IButtonProps) =>
    props.disabled === true ? 'not-allowed' : 'pointer'};

  transition: background-color 0.5s;
`;
